export const MONTHS = ["Month 1", "Month 2", "Month 3"] as const;
